import React, {useState} from "react";
import {Link, useHistory, useParams} from "react-router-dom";

// Search bar and taking inputs from the user.
const SearchBar = () => {
    const currZip = useParams().searchTerm;
    const currName = useParams().searchName;
    const [inputs, setInputs] = useState({zip:currZip, name:currName});
    const history = useHistory();
    let searchTerm = "/search/" + inputs.zip + "/" + inputs.name;

    const updateInput = (inp) => {
        setInputs({zip: inp.target.value, name:inputs.name});
        searchTerm = "/search/" + inputs.zip + "/" +  inputs.name;
    }
    const updateName = (inp) => {
        setInputs({zip: inputs.zip, name:inp.target.value});
        searchTerm = "/search/" + inputs.zip + "/" +  inputs.name;
    }

    return (
        <form className="d-flex">
            <input className="form-control mr-2 wd-zip"
                   onChange={updateInput}
                   value={inputs.zip}
                   id="zip-id" type="search"
                   placeholder="ZipCode"
                   aria-label="Search"/>
            {/*// defaultValue="02120"/>*/}
            <input className="form-control mr-2 wd-search"
                   onChange={updateName}
                   value={inputs.name}
                   id = "name"
                   type="search" placeholder="Search"
                   aria-label="Search"/>
            <div>
                <Link
                    to={{
                        pathname: searchTerm,
                        state: { x: [inputs.zip], y:[inputs.name] }
                    }}
                >
                    {
                        inputs.zip && inputs.name && <a style={{float: "right"}} className="wd-edit-btn me-2">
                            <button className="btn btn-info btn-light ms-2"
                                    type="submit">Search
                            </button>
                        </a>
                    }
                </Link>
            </div>
            <div>
                {
                    (!inputs.zip || !inputs.name) && <a style={{float: "right"}} className="wd-edit-btn me-2">
                        <button className="btn btn-info btn-light ms-2"
                                type="submit" disabled>Search
                        </button>
                    </a>
                }
            </div>
        </form>
    )
}

export default SearchBar;